import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import { InputContainer } from './loginStyles';

function LoginInput({ name, label, icon, ...rest }) {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  const Icon = icon && icon;

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, inputRef, registerField]);

  return (
    <InputContainer>
      <label htmlFor={fieldName}>{label}</label>

      <div>
        {icon && <Icon />}
        <input ref={inputRef} defaultValue={defaultValue} {...rest} />
      </div>

      {error && <span>{error}</span>}
    </InputContainer>
  );
}

export default LoginInput;
